<template>
  <div class="content-box">
    <div class="content">
      <div class="top-title">
        <img class="img-logo" src="./img/icon.png"/>
        <span class="logo-text">捷电猫</span>
      </div>
      <div class="introduceBOX wow animate__animated animate__fadeInUp">
        <img src="./img/img1.png" alt="" />
      </div>
      <div class="introduceBOX wow animate__animated animate__fadeInUp">
        <img src="./img/img2.png" alt="" />
      </div>
      <div class="introduceBOX wow animate__animated animate__fadeInUp">
        <img src="./img/img3.png" alt="" />
      </div>
      <div class="introduceBOX wow animate__animated animate__fadeInUp">
        <img src="./img/img4.png" alt="" />
      </div>
      <div class="introduceBOX wow animate__animated animate__fadeInUp">
        <img src="./img/img5.png" alt="" />
      </div>

      <div class="bottom-copy">
        <div class="bottom-view">
          <img class="img-logo-bottom" src="./img/icon.png"/>
          <span class="logo-text-bottom">捷电猫</span>
        </div>
        
        <div class="text-left">
          <span class="text-phone">联系我们 : 400-1818-168</span>
          <div class="copyright">
          Copyright@2025  深圳市心跳互联科技有限公司 版权所有    
          <span @click="go" class="info-num">粤ICP备2024356661号-2</span>&nbsp;&nbsp;&nbsp;&nbsp;
          <a style="color: #fff;" href="https://oss.xtlinks.cn/resource/files/agreement11324641237313781760.html">隐私协议</a>
        </div>
        </div>
        
      </div>
      
    </div>
  </div>
</template>

<script>
import "animate.css";
import { WOW } from "wowjs";
export default {
  data() {
    return {
      headerScroll: false, //透明判断
      btnFlag: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
    this.$nextTick(() => {
      //页面渲染完，在执行
      let wow = new WOW({
        live: false,
      });
      wow.init();
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },

  methods: {
    go() {
      // location.href = "https://beian.miit.gov.cn/#/Integrated/index";
      window.open("https://beian.miit.gov.cn/#/Integrated/index", "_blank");
    },
    // 点击回到顶部方法，加计时器是为了过渡顺滑
    backTop() {
      const upRoll = setInterval(() => {
        const top = document.documentElement.scrollTop; // 每次获取页面被卷去的部分
        const speed = Math.ceil(top / 10); // 每次滚动多少 （步长值）
        if (document.documentElement.scrollTop > 0) {
          document.documentElement.scrollTop -= speed; // 不在顶部 每次滚动到的位置
        } else {
          clearInterval(upRoll); // 回到顶部清除定时器
        }
      }, 10);
    },

    // 为了计算距离顶部的高度，当高度大于600显示回顶部图标，小于600则隐藏
    scrollToTop() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      that.scrollTop > 92
        ? (that.headerScroll = true)
        : (that.headerScroll = false);
      if (that.scrollTop > 600) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.content-box {
  width: 100%;
  background: #ffffff;
  height: 100%;
  min-width: 1200px;
  .content {
    position: relative;
    .top-title{
      display: flex;
      align-items: center;
      background: white;
      padding-left: 100px;
      padding-top: 20px;
      padding-bottom: 20px;
      /* 添加底部阴影 */
      box-shadow: 0 5px 10px -5px rgba(0, 0, 0, 0.3);
      .img-logo{
        height: 55px;
        width: 55px;
      }
      .logo-text{
        color: #050d20;
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        margin-left: 10px;
      }
    }
    .introduceBOX {
      img {
        width: 100%;
        height: 100%;
      }
    }
    .bottom-copy{
      display: flex;
      background: #050d20;
      padding: 20px 0 20px 100px;
      position: relative;
      .bottom-view{
        height: 55px;
        position: absolute;
        left: 100px;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        .img-logo-bottom{
          height: 55px;
        }
        .logo-text-bottom{
          color: #fff;
          font-size: 20px;
          margin-left: 10px;
        }
      }
      
      .text-left{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .text-phone{
          font-size: 16px;
          color: #fff;
        }
        .copyright {
          text-align: center;
          flex-wrap: wrap;
          font-size: 16px;
          color: #fff;
          margin-top: 10px;
          .info-num {
            cursor: pointer;
          }
        }
      }
      
    }

    
  }
  @keyframes shake {
    /* 水平抖动，核心代码 */
    10%,
    90% {
      transform: translate3d(-1px, 0, 0);
    }
    20%,
    80% {
      transform: translate3d(+2px, 0, 0);
    }
    30%,
    70% {
      transform: translate3d(-4px, 0, 0);
    }
    40%,
    60% {
      transform: translate3d(+4px, 0, 0);
    }
    50% {
      transform: translate3d(-4px, 0, 0);
    }
  }
}
a {
  outline: none;
}
</style>
